import { render, staticRenderFns } from "./PreviewPage.vue?vue&type=template&id=4f2f5ff1&scoped=true&"
import script from "./PreviewPage.vue?vue&type=script&lang=js&"
export * from "./PreviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPage.vue?vue&type=style&index=0&id=4f2f5ff1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f5ff1",
  null
  
)

export default component.exports